import {z} from 'zod';

export const SearchParams = z.object({
    page: z.number().default(1),
    pageSize: z.number().default(10),
    search: z.string().optional(),
    expiring_in_30_days: z.boolean().default(false),
    expired: z.boolean().default(false),
    type: z.enum(["MEDICAL", "NON_MEDICAL"]).default("MEDICAL"),
});

export const SearchParamsWithYear = SearchParams.extend({
    year: z.number().default(new Date().getFullYear()),
    out_of_stock: z.boolean().default(false),
    available: z.boolean().default(true),
    expired: z.boolean().default(false),
    expiring_in_30_days: z.boolean().default(false),
});

export type SearchParams = z.infer<typeof SearchParams>;
export type SearchParamsWithYear = z.infer<typeof SearchParamsWithYear>;